import { Carousel } from 'antd';
import styled from 'styled-components';

export const StyledCarousel = styled(Carousel)`
    margin: 0 auto;

    .slick-slide {
        display: flex !important;
        justify-content: center;
        align-items: center;

        .ant-image-img {
            border-radius: 4px;
        }
    }

    .slick-arrow {
        width: 32px;
        height: 32px;
        border-radius: 50%;

        &.slick-prev {
            &::after {
                inset-inline-start: ${({ theme: { token } }) => token.marginSM}px;
                top: ${({ theme: { token } }) => token.marginXS}px;
            }
        }

        &.slick-next {
            &::after {
                inset-inline-start: ${({ theme: { token } }) => token.marginXS}px;
                top: ${({ theme: { token } }) => token.marginXS}px;
            }
        }
    }

    &.image-gallery-medium {
        .slick-arrow {
            background: ${({ theme: { token } }) => token.carouselOutsetArrowColorBg};
            color: ${({ theme: { token } }) => token.carouselOutsetArrowColor};
        }
    }

    &.image-gallery-small {
        .slick-arrow {
            background: ${({ theme: { token } }) => token.carouselInsetArrowColorBg};
            color: ${({ theme: { token } }) => token.carouselInsetArrowColor};

            &.slick-prev {
                inset-inline-start: 0;
            }

            &.slick-next {
                inset-inline-end: 0;
            }
        }
    }
`;